import { BlockConfig, OperationTypes, ContentTypes } from "../block-base";
import { BlockTypes } from "../block-types";

export const databaseConfig: BlockConfig = {
  displayName: "Database",
  imagePath: "",
  isInitiator: true,
  isTerminator: false,
  isInterceptor: false,
  allowedInputTypes: new Set([
    BlockTypes.APP_SERVER,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.CACHE,
    BlockTypes.LAMBDA,
    BlockTypes.NETWORK_LOAD_BALANCER,
    BlockTypes.PASSTHROUGH,
  ]),
  allowedOutputTypes: new Set(),
  inputCapacity: {
    total: 3000,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 2250,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 500,
          [`${ContentTypes.STATIC}`]: 1000,
          [`${ContentTypes.STATIC_MEDIA}`]: 750,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 750,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 500,
          [`${ContentTypes.STATIC_MEDIA}`]: 250,
        },
      },
    },
  },
  processingCapacity: {
    total: 3000,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 2250,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 500,
          [`${ContentTypes.STATIC}`]: 1000,
          [`${ContentTypes.STATIC_MEDIA}`]: 750,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 750,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 500,
          [`${ContentTypes.STATIC_MEDIA}`]: 250,
        },
      },
    },
  },
  purchasePrice: 150,
  sellPrice: 75,
  costPerCycle: 1.2,
  outputConnectorLimits: {},
};
